<!--
 * @Description: 游戏管理分区列表
 * @Author: gao shuai
 * @Date: 2020-02-23 14:13:50
 * @LastEditTime: 2020-09-11 09:27:12
 * @LastEditors: gao shuai
 -->
<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><span class="local">你的位置</span></el-breadcrumb-item>
        <el-breadcrumb-item>游戏管理</el-breadcrumb-item>
        <el-breadcrumb-item>网关检测</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="opeartbox">
      <ul class="clearfix">
        <li>
          <span class='tit'>分区名称：</span>
          <span class="txtbox">
            <el-input style="width:120px;" size="small" v-model="partitionName" @input="tenantId=intNumber(tenantId)" placeholder="请输入内容"></el-input>
          </span>
        </li>
        <li>
          <span class='tit'>IP地址：</span>
          <span class="txtbox">
            <el-input style="width:120px;" size="small" v-model="ipAddress" placeholder="请输入内容"></el-input>
          </span>
        </li>
        <li>
          <span class='tit'>在线状态：</span>
          <span class="txtbox">
            <el-select style="width:120px;" v-model="statu" clearable size="small" placeholder="请选择">
              <el-option v-for="(item,i) in statudrow" :key="'statu'+i" :label="item.text" :value="item.value"></el-option>
            </el-select>
          </span>
        </li>
        <span class="mgl10">
            <el-button size="small" type="primary" @click="()=>{pageIndex=1;getlist()}">查询</el-button>
          </span>
      </ul>
    </div>
    <div class="gs_tablebox">
      <el-table ref="moduleTable" size="mini" :data="tableData" border style="width: 100%" stripe>
        <el-table-column prop="id" label="编号" width="60"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="110">
        </el-table-column>
        <el-table-column prop="partitionName" label="分区名称" width="240"></el-table-column>
        <el-table-column prop="ipAddress" label="IP地址" width="110">
        </el-table-column>
        <el-table-column prop="port" label="端口"></el-table-column>
        <el-table-column prop="lastHeartbeatTime" label="上次在线时间"></el-table-column>
        <el-table-column prop="isOnline" label="是否在线">
           <template slot-scope="scope">
    <el-tag :type="scope.row.isOnline ? 'success' : 'danger'" effect="dark">
      {{ scope.row.isOnline ? '在线' : '离线' }}
    </el-tag>
  </template>
        </el-table-column>
      </el-table>
      <div class="gs_pagenumber">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checkIndex: '', // 检测的Index
      statu: '', // 在线状态
      ipAddress:'',//ip地址
      partitionName:'',//分区名称
      statudrow: [
        { value: 1, text: '在线' },
        { value: 0, text: '离线' }
      ], // 启用状态下拉
      pageIndex: 1, // 页码
      pageSize: 10, // 每页的条数
      total: 0, // 总数据的条数
      tableData: []
    };
  },
  methods: {
    // 分组list
    getlist() {
      this.$api.game
        .clientInfoList({

          PartitionName: this.partitionName,
          IpAddress: this.ipAddress,
          IsOnline: this.statu === '' ? -1 : this.statu,
          PageNumber: this.pageIndex,
          PageSize: this.pageSize
        })
        .then((data) => {
          if (data.status === 204) {
            this.tableData = [];
            this.total = 0;
          } else if (data.status === 200) {
            this.tableData = data.data;
            this.total = JSON.parse(data.headers['x-pagination']).TotalCount;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },

    // 当每页条数变化时
    handleSizeChange(data) {
      this.pageSize = data;
      this.pageIndex = 1;
      this.getlist();
    },
    // 当前的页码变化时
    handleCurrentChange(data) {
      this.pageIndex = data;
      this.getlist();
    },
      // 启动定时刷新
    startRefreshTimer() {
      this.refreshTimer = setInterval(() => {
        this.getlist();
      }, 5000); // 每5秒刷新一次
    },
    // 停止定时刷新
    stopRefreshTimer() {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer);
        this.refreshTimer = null;
      }
    }
  },
  created() {
    this.getlist();
    this.startRefreshTimer();
  },
  beforeDestroy() {
    this.stopRefreshTimer(); // 组件销毁前清除定时器，防止内存泄漏
  }
};
</script>

<style lang="scss" scoped>
.opeartbox {
  padding: 15px 20px 5px;
  background: #fff;
  ul {
    li {
      float: left;
      margin-right: 15px;
      margin-bottom: 10px;
      .tit {
        font-size: 14px;
        color: #2d2d2d;
        margin-right: 5px;
      }
      .txtbox {
        display: inline-block;
      }
    }
  }
}
.tableinfo {
  background: #fff;
  padding: 15px 20px;
  table {
    width: 100%;
    color: #272727;
    font-size: 14px;
    td {
      height: 30px;
    }
    .c_3fa396 {
      color: #3fa396;
    }
  }
}
</style>
